/* LIQUID_GOLD: Rally Event Landing Page — countdown timer and scroll animations */

window.LiquidGold = window.LiquidGold || {};

/* LIQUID_GOLD: Countdown timer — reads target date from data attribute on container */
window.LiquidGold.eventCountdown = {
  init() {
    const container = document.querySelector('[data-lg-countdown-target]');
    if (!container) return;

    const target = new Date(container.dataset.lgCountdownTarget).getTime();

    const daysEl  = document.getElementById('lg-cd-days');
    const hoursEl = document.getElementById('lg-cd-hours');
    const minsEl  = document.getElementById('lg-cd-mins');
    const secsEl  = document.getElementById('lg-cd-secs');

    if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

    function tick() {
      const diff = target - Date.now();

      if (diff <= 0) {
        daysEl.textContent  = '0';
        hoursEl.textContent = '00';
        minsEl.textContent  = '00';
        secsEl.textContent  = '00';
        clearInterval(interval);
        return;
      }

      const days  = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins  = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs  = Math.floor((diff % (1000 * 60)) / 1000);

      daysEl.textContent  = days;
      hoursEl.textContent = String(hours).padStart(2, '0');
      minsEl.textContent  = String(mins).padStart(2, '0');
      secsEl.textContent  = String(secs).padStart(2, '0');
    }

    tick();
    var interval = setInterval(tick, 1000);
  }
};

/* LIQUID_GOLD: Scroll-reveal animations using IntersectionObserver */
window.LiquidGold.scrollReveal = {
  init() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.lg-fu').forEach(function(el) {
        el.classList.add('lg-fu--visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var siblings = entry.target.parentElement.querySelectorAll('.lg-fu:not(.lg-fu--visible)');
          siblings.forEach(function(s, i) {
            setTimeout(function() { s.classList.add('lg-fu--visible'); }, i * 75);
          });
          entry.target.classList.add('lg-fu--visible');
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.lg-fu').forEach(function(el) {
      observer.observe(el);
    });
  }
};

document.addEventListener('DOMContentLoaded', function() {
  window.LiquidGold.eventCountdown.init();
  window.LiquidGold.scrollReveal.init();
});
